import React from 'react';
import { Link } from 'react-router-dom';

export function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="text-xl font-bold text-blue-600 hover:text-blue-700">
            ContextLoom
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white shadow-md rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
          <p className="text-sm text-gray-600 mb-8">Last updated: November 17, 2025</p>

          <div className="prose prose-blue max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 mb-4">
                By accessing and using ContextLoom ("Service"), you accept and agree to be bound by the terms and
                provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Use License</h2>
              <p className="text-gray-700 mb-4">
                Permission is granted to temporarily access the Service for personal, non-commercial transitory viewing only.
                This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the Service</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Disclaimer</h2>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
                <p className="text-gray-800 font-semibold mb-2">IMPORTANT LEGAL NOTICE</p>
                <p className="text-gray-700">
                  THE MATERIALS ON CONTEXTLOOM'S WEBSITE ARE PROVIDED ON AN 'AS IS' BASIS. CONTEXTLOOM MAKES NO WARRANTIES,
                  EXPRESSED OR IMPLIED, AND HEREBY DISCLAIMS AND NEGATES ALL OTHER WARRANTIES INCLUDING, WITHOUT LIMITATION,
                  IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT
                  OF INTELLECTUAL PROPERTY OR OTHER VIOLATION OF RIGHTS.
                </p>
              </div>
              <p className="text-gray-700 mb-4">
                Further, ContextLoom does not warrant or make any representations concerning the accuracy, likely results,
                or reliability of the use of the materials on its website or otherwise relating to such materials or on any
                sites linked to this site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitations</h2>
              <p className="text-gray-700 mb-4">
                In no event shall ContextLoom or its suppliers be liable for any damages (including, without limitation,
                damages for loss of data or profit, or due to business interruption) arising out of the use or inability
                to use the materials on ContextLoom's website, even if ContextLoom or a ContextLoom authorized representative
                has been notified orally or in writing of the possibility of such damage.
              </p>
              <p className="text-gray-700 mb-4">
                Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for
                consequential or incidental damages, these limitations may not apply to you.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Accuracy of Materials</h2>
              <p className="text-gray-700 mb-4">
                The materials appearing on ContextLoom's website could include technical, typographical, or photographic errors.
                ContextLoom does not warrant that any of the materials on its website are accurate, complete or current.
                ContextLoom may make changes to the materials contained on its website at any time without notice. However,
                ContextLoom does not make any commitment to update the materials.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Links</h2>
              <p className="text-gray-700 mb-4">
                ContextLoom has not reviewed all of the sites linked to its website and is not responsible for the contents
                of any such linked site. The inclusion of any link does not imply endorsement by ContextLoom of the site.
                Use of any such linked website is at the user's own risk.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Modifications</h2>
              <p className="text-gray-700 mb-4">
                ContextLoom may revise these terms of service for its website at any time without notice. By using this
                website you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Governing Law</h2>
              <p className="text-gray-700 mb-4">
                These terms and conditions are governed by and construed in accordance with the laws of the United States
                and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Information</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about these Terms, please contact us at:
              </p>
              <p className="text-gray-700">
                Email: <a href="mailto:legal@contextloom.ai" className="text-blue-600 hover:text-blue-700">legal@contextloom.ai</a>
              </p>
            </section>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex justify-between text-sm text-gray-600">
              <Link to="/legal/privacy" className="hover:text-blue-600">Privacy Policy</Link>
              <Link to="/" className="hover:text-blue-600">Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
